import { Upload } from '@wellesley/openapi'
import { Avatar, AvatarFallback, AvatarImage, cn } from '@wellesley/ui'
import { selectUploadFile } from '@wellesley/uploads'
import { cropName } from 'helpers/cropName'

import { FC } from 'react'

type ChannelAvatarProps = {
  image?: Upload | null
  name: string
  className?: string
}
export const ChannelAvatar: FC<ChannelAvatarProps> = ({
  image,
  name,
  className,
}) => {
  const src = selectUploadFile({ size: 48, upload: image })?.uri
  return (
    <Avatar className={cn('h-xs w-6 rounded-none', className)}>
      <AvatarImage src={src || undefined} alt="channel-avatar" />
      <AvatarFallback className="rounded-xs bg-gray-700 text-xs">
        {cropName(name)}
      </AvatarFallback>
    </Avatar>
  )
}
